import { useTranslation } from 'react-i18next';

interface StubPageProps {
  navKey: 'hsLookup' | 'dutyCalc' | 'docGenerator' | 'tnvedMatcher';
}

/**
 * Универсальная stub-страница для модулей, у которых ещё нет UI.
 * Текст и заголовок берутся из i18n, чтобы все три локали работали из коробки.
 */
export function StubPage({ navKey }: StubPageProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <section className="rounded-lg border border-ntr-primary/10 bg-white p-8 shadow-sm">
      <p className="text-xs font-semibold uppercase tracking-widest text-ntr-accent">
        {t('stub.comingSoon')}
      </p>
      <h2 className="mt-2 text-2xl font-semibold text-ntr-primary">
        {t(`nav.${navKey}`)}
      </h2>
      <p className="mt-3 text-sm text-ntr-muted">{t('stub.description')}</p>
    </section>
  );
}
